export const accessCodeFor = (saiConnectId, dateOfBirth) => {
    const isoMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateOfBirth);
    const displayMatch = /^(\d{2})-(\d{2})-(\d{4})$/.exec(dateOfBirth);
    if (!isoMatch && !displayMatch) return null;

    const [, first, month, last] = isoMatch || displayMatch;
    const year = isoMatch ? first : last;
    const day = isoMatch ? last : first;
    const parsed = new Date(`${year}-${month}-${day}T00:00:00Z`);
    const isValidDate =
        parsed.getUTCFullYear() === Number(year) &&
        parsed.getUTCMonth() + 1 === Number(month) &&
        parsed.getUTCDate() === Number(day);
    if (!isValidDate) return null;

    return `${saiConnectId.trim()}${day}${month}${year}`;
};

export const formatDobInput = (value) => {
    const digits = String(value).replace(/\D/g, "").slice(0, 8);
    if (digits.length <= 2) return digits;
    if (digits.length <= 4) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
    return `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4)}`;
};
